<template>
  <div :class="classObj" class="app-wrapper">
    <!--    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>-->
    <div class="main-container">
      <el-top-nav-menu-3
        ref="topNavMenu"
        :subMenu="menu"
        appTitle="模板应用"
        companyTitle="交建云商运营中心"
        dashboard="/dashboard"
        class="no-print"
        @onSubmitSkip="onJump"
      ></el-top-nav-menu-3>
      <div class="main-wrapper">
        <div v-show="sidebar.opened" class="sidebar-wrapper no-print">
          <div>
            <sidebar
              :title="subMenuTitle"
              :left-menu="currentMenuArr"
              class="sidebar-container"
            />
          </div>
        </div>
        <app-main style="min-height: auto" />
      </div>
      <!--      <CFooter v-if="isShowFooter" class="no-print"/>-->
    </div>
  </div>
</template>

<script>
import { Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { isExternal } from "@/utils/validate";
import Cookies from "js-cookie";
import arrows from "@/assets/images/arrows.png";
// import CFooter from './components/footer/footer'

export default {
  name: "Layout",
  components: {
    Sidebar,
    AppMain,
    // CFooter
  },
  mixins: [ResizeMixin],
  data() {
    return {
      arrows,
      counter: 0,
      isShowSidebar: false,
      isShowSidebarSystem: this.$store.state.app.sidebar.isShowSidebarBtn,
      topMenuObj: {},
      routeMenu: [],
      leftMenu: [],
      subMenuTitle: "",
      currentMenuObj: {},
      currentParentMenuObj: {},
      tempMenu: [],
      menu: [
        {
          id: "2-1",
          pid: "2",
          orderId: 1,
          name: "功能模块",
          url: "/tmpl/demo/demo-table",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-1-1",
              pid: "2-1",
              orderId: 1,
              name: "表格示例",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-1-1-1",
                  pid: "2-1-1",
                  orderId: 1,
                  name: "table表格",
                  url: "/tmpl/demo/demo-table/demo-list",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "tmpl-demo-demo-table-demo-list",
                  subMenu: [],
                },
                {
                  id: "2-1-1-2",
                  pid: "2-1-1",
                  orderId: 2,
                  name: "table表格排序筛选",
                  url: "/tmpl/demo/demo-table/demo-table-sortable",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-table-sortable",
                  subMenu: [],
                },
                {
                  id: "2-1-1-3",
                  pid: "2-1-1",
                  orderId: 3,
                  name: "树形表格嵌套表单",
                  url: "/tmpl/demo/demo-table/demo-table-checkbox",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-table-checkbox",
                  subMenu: [],
                },
                {
                  id: "2-1-1-4",
                  pid: "2-1-1",
                  orderId: 4,
                  name: "树形表格和自定义显示列",
                  url: "/tmpl/demo/demo-table/demo-table-tree-custom",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-table-tree-custom",
                  subMenu: [],
                },
              ],
            },
          ],
        },
        {
          id: "2-2",
          pid: "2",
          orderId: 7,
          name: "基础数据",
          url: "/tmpl/base",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-2-1",
              pid: "2-2",
              orderId: 3,
              name: "练习项目",
              url: "/tmpl/base/project",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-2-1-1",
                  pid: "2-2-1",
                  orderId: 3,
                  name: "练习项目",
                  url: "/tmpl/base/project/project-list",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "tmpl-base-project-project-list",
                  subMenu: [],
                },
              ],
            },
          ],
        },
        {
          id: "2-3",
          pid: "2",
          orderId: 10,
          name: "统计报表",
          url: "/tmpl/order/purchaser/purchase-daily",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-3-1",
              pid: "2-3",
              orderId: 3,
              name: "订单",
              url: "/statistic/order",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-3-1-1",
                  pid: "2-3-1",
                  orderId: 3,
                  name: "订单采购统计表",
                  url: "/tmpl/order/purchaser/purchase-daily",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "statistic-order-purchaser-purchase-daily",
                  subMenu: [],
                },
              ],
            },
            {
              id: "2-3-2",
              pid: "2-3",
              orderId: 11,
              name: "主页模板",
              url: "/tmpl/homepage",
              hasStatistics: false,
              isShowSideBar: false,
              activeIndex: null,
              subMenu: [],
            },
          ],
        },
        {
          id: "2-4",
          pid: "2",
          orderId: 11,
          name: "运营组织",
          url: "/tmpl/operation-org/operation-org-table",
          hasStatistics: false,
          isShowSideBar: false,
          activeIndex: null,
        },
        {
          id: "2-5",
          pid: "2",
          orderId: 11,
          name: "详情页",
          url: "/tmpl/demo/demo-detail-info-list/demo-detail-info",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-5-1",
              pid: "2-5",
              orderId: 1,
              name: "详情页示例",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-5-1-1",
                  pid: "2-5-1",
                  orderId: 1,
                  name: "详情页",
                  url: "/tmpl/demo/demo-detail-info-list/demo-detail-info",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-detail-info",
                  subMenu: [],
                },
              ],
            },
          ],
        },
        {
          id: "2-6",
          pid: "2",
          orderId: 12,
          name: "标签页",
          url: "/tmpl/demo/demo-tabs/demo-tabs-custom",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-6-1",
              pid: "2-6",
              orderId: 1,
              name: "标签页定制示例",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-6-1-1",
                  pid: "2-6-1",
                  orderId: 1,
                  name: "标签页定制样式",
                  url: "/tmpl/demo/demo-tabs/demo-tabs-custom",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-tabs-custom",
                  subMenu: [],
                },
              ],
            },
          ],
        },
        {
          id: "2-7",
          pid: "2",
          orderId: 13,
          name: "列表",
          url: "/tmpl/demo/demo-lists/demo-lists-commodity",
          hasStatistics: false,
          isShowSideBar: true,
          activeIndex: null,
          subMenu: [
            {
              id: "2-7-1",
              pid: "2-7",
              orderId: 1,
              name: "列表示例",
              hasStatistics: false,
              isShowSideBar: true,
              activeIndex: null,
              subMenu: [
                {
                  id: "2-7-1-1",
                  pid: "2-7-1",
                  orderId: 1,
                  name: "上架商品列表",
                  url: "/tmpl/demo/demo-lists/demo-lists-commodity",
                  hasStatistics: true,
                  isShowSideBar: true,
                  activeIndex: null,
                  menuCode: "demo-lists-commodity",
                  subMenu: [],
                },
              ],
            },
          ],
        },
      ],
      activeIndex: "2",
    };
  },
  computed: {
    isShowFooter() {
      return this.$store.state.app.isShowFooter;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
    currentMenuArr() {
      return this.$store.state.app.currentMenuArr;
    },
  },
  mounted() {
    if (this.$route.path === "/test/test") {
      return;
    }
    this.$store.dispatch("setMenu", this.menu);

    this.setMenu(this.$store.state.app.menu, this.$route.name);

    const sidebarStatus = Cookies.get("sidebarStatus") - 0;
    this.isShowSidebar = !!sidebarStatus;
  },
  methods: {
    userPanelClickHandler(index) {
      // if (this.menu[index].name === '组织 管理') {
      //   return
      // }
      if (this.menu[index].url === "/to-be-built/index") {
        this.$message("工程建设中");
        return;
      }

      const len = this.menu.length;
      for (let i = 0; i < len; i++) {
        if (i === index) {
          // this.$router.push(this.menu[i].url)
          if (this.menu[i].url.indexOf("http") !== -1) {
            window.location.href = this.menu[i].url;
          } else {
            this.$router.push(this.menu[i].url);
            // this.setMenuToRoute(this.menu[i])
            // this.onJump(this.menu[i])
          }
          if (this.tempMenu.length) {
            const len1 = this.tempMenu.length;
            for (let j = 0; j < len1; j++) {
              if (this.tempMenu[j].id === this.menu[i].id) {
                return;
              }
            }
          }
          this.menu[i].isNotShow = false;
          this.tempMenu.push(this.menu[i]);

          // window.location.href = this.menu[i].url
        }
      }

      if (this.tempMenu.length > 1) {
        const shiftItem = this.tempMenu.shift();
        this.menu.forEach((item, i) => {
          if (item.id === shiftItem.id) {
            item.isNotShow = true;
          }
        });
      }
    },
    goHomePage() {
      // this.$router.push('/dashboard')
      window.location.href = "http://localhost/app/pmc/#/dashboard";
    },
    showSubMenu() {
      // this.$refs.topNavMenu.setCur(5)
      // const url = 'http://localhost/app/approval/#/approval/supplier/supplier-list'
      const url = "http://localhost/app/pmc/approval/#/dashboard";
      window.location.href = url;
      // window.open(url, '_blank')
    },
    onToggle() {
      this.isShowSidebar = !this.isShowSidebar;
      this.$store.dispatch("toggleSidebar");
    },
    handleClickOutside() {
      this.$store.dispatch("closeSidebar", { withoutAnimation: false });
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
    },
    onJump(obj) {
      // console.log(999)
      // console.log(obj)

      this.routeMenu = [];
      this.subMenuTitle = "";

      if (!isExternal(obj.url)) {
        // alert(obj.isShowSideBar)
        this.$router.push(obj.url);
        // this.isShowSidebarSystem = obj.isShowSidebar
        if (obj.isShowSideBar) {
          // alert(1)
          this.setMenuToRoute(obj);
          // const sidebarStatus = Cookies.get('sidebarStatus') - 0
          // if (sidebarStatus) {
          //   this.$store.dispatch('openSidebarTemporary')
          // } else {
          //   this.$store.dispatch('closeSidebarTemporary')
          // }
          this.$store.dispatch("openSidebarTemporary");
        } else {
          this.$store.dispatch("closeSidebarTemporary");
        }
      } else {
        // this.isShowSidebarSystem = false
        this.handleClickOutside();
      }
    },
    routerObj2MenuObj(item) {
      const menuObj = {};
      menuObj.subMenuTitle = item.name;
      if (item.subMenu.length) {
        const subMenuArr = [];
        item.subMenu.forEach((menuItem) => {
          subMenuArr.push(this.trans(menuItem));
        });
        menuObj.subMenu = subMenuArr;
      }
      return menuObj;
    },
    setMenuToRoute(obj) {
      // const that = this
      if (obj.subMenu.length) {
        const arr = obj.subMenu;
        const arrMenu = [];

        arr.forEach((item) => {
          const menuObj = this.routerObj2MenuObj(item);
          arrMenu.push(menuObj);
        });
        this.$store.dispatch("setCurrentMenuArr", arrMenu);

        this.leftMenu = this.$store.state.app.currentMenuArr;

        this.subMenuTitle = obj.subMenu[0].name;

        const routeObj = this.trans(obj);
        const subMenu = [];
        obj.subMenu.forEach((item) => {
          if (item.subMenu.length) {
            item.subMenu.forEach((item) => {
              const objTemp = this.trans(item);
              subMenu.push(objTemp);
            });
            routeObj.children = subMenu;
          }
        });

        this.routeMenu = subMenu;
      }
    },
    trans(obj) {
      const _routeObj = {};
      _routeObj.name = obj.name;
      _routeObj.path = obj.url;
      _routeObj.redirect = obj.redirect || "";
      _routeObj.meta = obj.meta || {};
      _routeObj.meta.title = obj.name;
      _routeObj.meta.isNotShow = obj.isNotShow;
      // _routeObj.children = obj.subMenu[0].subMenu
      // _routeObj.children = []
      // if (obj.subMenu[0].subMenu.length) {
      //
      //
      // }
      return _routeObj;
    },
    setMenu(arr, menuCode) {
      const that = this;

      if (arr.length !== 0) {
        var traverse = (arr) => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取当前菜单
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                this.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];

                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
            }
          }
        };
        traverse(arr);
      }
    },
    setParentMenu(arr, pid, index) {
      if (arr.length !== 0) {
        var traverse = (arr) => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // console.log(arr[i].menuCode)
              // 获取父菜单
              if (arr[i].id === pid) {
                // 获取三级菜单的上级菜单
                if (arr[i].id.split("-").length === 2) {
                  this.currentParentMenuObj = arr[i];
                  arr[i].activeIndex = index;
                  // return
                }
                // 获取二级菜单的上级菜单
                if (arr[i].id.split("-").length === 1) {
                  // this.currentParentMenuObj = arr[i]
                  arr[i].activeIndex = index;
                }

                // 设置上级菜单
                this.setParentMenu(this.menu, arr[i].pid, arr[i].id);

                // 设置当前一级菜单
                // if (arr[i].pid === null) {
                //   that.activeIndex = arr[i].orderId + ''
                // }
              }
              traverse(arr[i].subMenu);
            } else {
              // console.log(arr[i].menuCode)
              if (arr[i].id === pid) {
                // console.log(arr[i])
                arr[i].activeIndex = index;
              }
            }
          }
        };
        traverse(arr);
      }

      if (
        this.currentParentMenuObj.subMenu &&
        this.currentParentMenuObj.subMenu.length
      ) {
        this.setMenuToRoute(this.currentParentMenuObj);
      }
    },
    logout() {
      window.location.href = "http://tmpl.iccec.cn/";
    },
  },
  // watch: {
  //   isShowSidebarSystem() {
  //     return this.$store.state.app.sidebar.isShowSidebarBtn
  //   },
  //   isShowSidebar(){
  //     return
  //   }
  // }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .main-container {
    //width: 1440px;
    /*position: relative;*/

    min-height: 100%;
    background-color: #f1f1f1;
    //transition: margin-left .28s;
    //margin-left: $sideBarWidth;
    .main-wrapper {
      position: relative;
      min-width: 900px;
      max-width: 1680px;
      margin: 0 auto;
      /*padding: 12px 50px 0;*/
      padding: 20px 50px 0;

      .sidebar-wrapper {
        position: absolute;
        top: 20px;
        left: 50px;
        width: 180px;
        /*min-height: calc(100vh - 124px);*/
        /*border: 1px solid #ececec;*/
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07);
        border-top: 0;

        & > div {
          position: relative;
          min-height: calc(100vh - 160px);
        }
      }

      .toggle-btn {
        position: absolute;
        top: 24px;
        left: 186px;
        cursor: pointer;
        width: 12px;
        height: 30px;
        background: rgba(85, 118, 207, 1);
        border-radius: 6px;
      }
    }
  }

  &.hideSidebar {
    .main-container {
      .main-wrapper {
        /deep/ .toggle-btn {
          /*margin: 0;*/
          top: 24px;
          left: 4px;
        }

        /deep/ .sidebar-wrapper {
          left: 0 !important;
        }
      }
    }
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
<style rel="stylesheet/scss" lang="scss">
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.el-popover.user-popover {
  top: 27px !important;
  padding-top: 0 !important;
  border-radius: 0 !important;

  .el-menu {
    border: 0;

    .el-menu-item {
      margin: 0 -4px;
      padding-left: 4px !important;
      padding-right: 4px;
      height: 32px;
      line-height: 32px;

      &.user-info {
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid $--color-assist-background;
      }

      &.show-bottom-line {
        border-bottom: 1px solid $--color-assist-background;
      }

      .icon-ccui-user-wrapper {
        margin-bottom: 0;
        display: inline-block;
        color: #fff;
        width: 14px;
        height: 14px;
        font-size: 14px;
        border-radius: 7px;
        background-color: $--color-primary;
        overflow: hidden;

        i {
          color: $white;
        }

        span {
          color: #666;
        }
      }
    }
  }
}
</style>
